// extracted by mini-css-extract-plugin
export default {"table":"InformationTable_table__r6I6h"};